<template>
  <Menu
    v-slot="{ open }"
    as="div"
    class="relative block text-left text-sm lg:text-base"
  >
    <div>
      <MenuButton
        class="inline-flex min-w-48 max-w-56 items-center justify-between gap-3 rounded-lg border border-highlight bg-white px-4 py-2 text-highlight md:max-w-72"
      >
        <span>{{ selectedRefinement?.label ?? '-' }}</span>
        <ChevronDownIcon
          :class="{ 'rotate-180': open }"
          class="-mr-1 size-5 text-highlight duration-200"
          aria-hidden="true"
        />
      </MenuButton>
    </div>

    <transition
      enter-active-class="transition ease-out duration-100"
      enter-from-class="transform opacity-0 scale-95"
      enter-to-class="transform opacity-100 scale-100"
      leave-active-class="transition ease-in duration-75"
      leave-from-class="transform opacity-100 scale-100"
      leave-to-class="transform opacity-0 scale-95"
    >
      <MenuItems
        class="focus:outline-hidden absolute right-0 z-10 w-full origin-top-right rounded-md bg-white text-right shadow-lg ring-1 ring-black/5 focus-visible:outline-none"
      >
        <div class="py-1">
          <MenuItem v-for="item in items" :key="item.value" v-slot="{ active }">
            <button
              :class="[
                selectedRefinement || active
                  ? 'outline-hidden text-gray-900'
                  : 'text-gray-700',
                'hover:outline-hidden block w-full cursor-pointer px-4 py-2 text-left hover:bg-gray-100 hover:text-gray-900',
              ]"
              @click="() => emit('on-selection-changed', item.value)"
            >
              {{ item.label }}
            </button>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </Menu>
</template>

<script setup lang="ts">
import { AlgoliaSortingOption } from '@/types/Algolia/AlgoliaSortingOption';
import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue';
import { ChevronDownIcon } from '@heroicons/vue/20/solid';
import _ from 'lodash';
import { computed } from 'vue';

export type SortSelectProps = {
  items: AlgoliaSortingOption[];
  currentRefinement: string;
};

const { items, currentRefinement } = defineProps<SortSelectProps>();
const emit = defineEmits<{ 'on-selection-changed': [value: string] }>();

const selectedRefinement = computed(() =>
  _.find(items, { value: currentRefinement })
);
</script>
